var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
import { Outlet as RawOutlet } from 'react-router-dom';
import { FallbackComponent } from '../fallback';
export var Outlet = function (props) {
  return _jsx(Suspense, __assign({
    fallback: _jsx(FallbackComponent, {
      requesting: true
    })
  }, {
    children: _jsx(RawOutlet, __assign({}, props))
  }));
};